import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-sign-in',
  templateUrl: './icon-sign-in.component.html',
  styleUrls: ['./icon-sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconSignInComponent {}
